module.exports = __webpack_public_path__ + "media/bootstrap-icons/check2-circle-e7ab9d9d.svg";